// Parse a partially-streamed AI response into summary + file progress.
export function parseStream(raw = "") {
  const sm = raw.match(/<summary>([\s\S]*?)(<\/summary>|$)/);
  const summary = sm ? sm[1].replace(/<[^>]*$/, "").trim() : "";
  const files = [];
  const re = /<file\s+path="([^"]+)"\s*>/g;
  let m;
  while ((m = re.exec(raw))) {
    const start = m.index + m[0].length;
    const end = raw.indexOf("</file>", start);
    const done = end !== -1;
    const body = raw.slice(start, done ? end : undefined);
    const lines = body.split("\n");
    files.push({ path: m[1], done, lines: lines.length, tail: done ? "" : lines.slice(-12).join("\n") });
  }
  return { summary, files, current: files.find((f) => !f.done) || null };
}

export const timeAgo = (iso) => {
  if (!iso) return "";
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
